import * as personTypesActions from './actions';
import personTypesReducer from './reducer';
import * as personTypesTypes from './types';

export {personTypesActions, personTypesTypes};

export default personTypesReducer;
